// extracted by mini-css-extract-plugin
export default {"option":"SideBarMenuOption_option__v7+Us","active":"SideBarMenuOption_active__eNGg0","light":"SideBarMenuOption_light__vKdSq","dark":"SideBarMenuOption_dark__RfyVH"};